import axios from "../../utils/request";

const getDefaultGeneralState = () => {
    return {
        services: { status: false, data: [] },
        defaultServices: { status: false, data: [] },
        productTypes: { status: false, data: [] },
        cities: { status: false, data: [] },
        countries: { status: false, data: [] },
        venues: { status: false, data: [] },
        venuesWithQGateway: { status: false, data: [] },
    }
};

const state = getDefaultGeneralState();

const getters = {
    getServices: (state) => state.services,
    getDefaultServices: (state) => state.defaultServices,
    getProductTypes: (state) => state.productTypes,
    getCountries: (state) => state.countries,
    getCities: (state) => state.cities,
    getVenues: (state) => state.venues,
    getVenuesWithQGateway: (state) => state.venuesWithQGateway,
};

const actions = {
    loadServices({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("services").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit("setServices", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    loadDefaultServices({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("services/default-services").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        console.log("default");

                        console.log(data);
                        commit("setDefaultServices", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    loadProductTypes({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get("venues/product-types")
                .then((response) => {
                    if (response.status == 200 && response.data.status == true) {
                        console.log(response.data.data);
                        commit("setProductTypes", response.data.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    loadCities({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("cities").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit("setCities", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    loadCountries({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("countries").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit("setCountries", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    loadVenuesWithQGateway({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("venues/venuesWithQGateWay").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit("setVenuesWithQGateway", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    loadVenues({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("venues/short").then(
                (response) => {
                    if (response.status == 200 && response.data.status == true) {
                        let data = response.data.data;
                        commit("setVenues", data);
                        resolve(response);
                    }
                    reject(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};
/* eslint-disable */
const mutations = {
    setServices: (state, data) => {
        state.services.data = data;
        state.services.status = true;
    },
    setDefaultServices: (state, data) => {
        state.defaultServices.data = data;
        state.defaultServices.status = true;
    },
    setProductTypes: (state, data) => {
        state.productTypes.data = data;
        state.productTypes.status = true;
    },
    setCountries: (state, data) => {
        state.countries.data = data;
        state.countries.status = true;
    },
    setCities: (state, data) => {
        state.cities.data = data;
        state.cities.status = true;
    },
    setVenues: (state, data) => {
        state.venues.data = data;
        state.venues.status = true;
    },
    setVenuesWithQGateway: (state, data) => {
        state.venuesWithQGateway.data = data;
        state.venuesWithQGateway.status = true;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};